import React, { useState } from 'react'
import ProdComponent from './prodComponent/ProdComponent'
import Slider from 'infinite-react-carousel';


import "./Products.css"
import Prod1 from "../../../assets/imgs/product/prodImg.jpeg"
import Navbar from '../../Navbar/Navbar'
import Carroussel from './Carousel';
import ProdSliderComp from './prodSliderComp/ProdSliderComp';
function Products() {


  const [view, setview] = useState(false)

  let cards = [
    {
      key: 1,
      content: (
        // <Card imagen="https://updates.theme-fusion.com/wp-content/uploads/2017/12/convertplus_thumbnail.jpg" />
        <img src='https://picsum.photos/604/400' alt='1' />
      )
    },
    {
      key: 2,
      content: (
        // <Card imagen="https://updates.theme-fusion.com/wp-content/uploads/2017/12/acf_pro.png" />
        <img src='https://picsum.photos/602/400' alt='2' />
      )
    },
    {
      key: 3,
      content: (
        // <Card imagen="https://updates.theme-fusion.com/wp-content/uploads/2017/12/layer_slider_plugin_thumb.png" />
        <img src='https://picsum.photos/601/400' alt='3' />
      )
    },
    {
      key: 4,
      content: (
        // <Card imagen="https://updates.theme-fusion.com/wp-content/uploads/2016/08/slider_revolution-1.png" />
        <img src='https://picsum.photos/607/400' alt='4' />
      )
    },
    {
      key: 5,
      content: (
        // <Card imagen="https://updates.theme-fusion.com/wp-content/uploads/2019/01/pwa_880_660.jpg" />
        <img src='https://picsum.photos/608/400' alt='5' />
      )
    }
  ];

  const handleView = () => {
    setview(!view)
  }



  return (
    <>
    <Navbar />
      <div className={view ? 'product product-blur' : "product"}>
        <section id='p-start'>
          <h2 className='p-head'>Products</h2>
          <div>
            <Carroussel
              cards={cards}
              
              offset={2}
              showArrows={false} />
          </div>


        </section>
        <section id='products' className='animate__animated animate__zoomIn'>
          <h2 className='p-head'>Products</h2>
          <div style={{width:"100vw"}}>
          <Slider dots arrows={false} wheel={true} slidesToShow={3} className='p-list'>
            
            <ProdSliderComp handleView={handleView}/>
            <ProdSliderComp handleView={handleView}/>
            <ProdSliderComp handleView={handleView}/>
            <ProdSliderComp handleView={handleView}/>

          </Slider>
         
          </div>
        </section>

        <section id='explore'>
          <h2 className='p-head'>Explore</h2>

        </section>
        <section id='consumers'>
          <div className='con-text'>
            <p>Total Consumers</p>
            <p>2500</p>
          </div>
          <div className='con-text'>
            <p>Customers Satisfaction</p>
            <p>100%</p>
          </div>
          <div className='con-text'>
            <p>Total Products</p>
            <p>500</p>
          </div>
        </section>

        <section id='contact'>
          <button>Contact Us</button>
        </section>



      </div>
      {view &&  <div className={view ? 'animate__animated animate__zoomIn indi-prod' : 'animate__animated animate__zoomOut'}>
        <ProdComponent handleProdClose={handleView} />

      </div>}
   

    </>
  )
}

export default Products
